import React, { useState, useEffect, useCallback } from "react";
import SideBar from "../Components/SideBar";
import SearchBar from "../Components/SearchBar";
import { getProfile } from "../Services/usersApi";
import { deleteAppointments } from "../Services/appointmentBookingApi";
import {
  getListings,
  getMyListing,
  deleteListing,
  updateListingsStatus,

} from "../Services/listingsApi";
import { useNavigate } from "react-router-dom";
import { role } from "../Constants/role";
import { status, statusByName } from "../Constants/status";
import { useTranslation } from "react-i18next";
import LISTINGSIMAGE from "../assets/ListingsImage.jpg";
import { getCategory } from "../Services/CategoryApi";
// import APPOINTMENTDEFAULTIMAGE from "../assets/Appointments.png";
import { getCitiesByUserId } from "../Services/citiesApi";
import { hiddenCategories } from "../Constants/hiddenCategories";
import { ClipLoader } from "react-spinners";

/** Strip ?query and #fragment so file extensions match on absolute CDN URLs. */
function pathForExtensionCheck(path) {
  if (!path || typeof path !== "string") return "";
  const cut = path.search(/[?#]/);
  return cut === -1 ? path : path.slice(0, cut);
}

function isListingImagePath(path) {
  return /\.(jpg|jpeg|png|gif|webp|avif)$/i.test(pathForExtensionCheck(path));
}

function isListingPdfPath(path) {
  return pathForExtensionCheck(path).toLowerCase().endsWith(".pdf");
}

/** Read the current tab from the ?status= query param → numeric statusId (null = All). */
function readStatusFromUrl() {
  const raw = new URLSearchParams(window.location.search).get("status");
  if (!raw) return null;
  const match = Object.keys(statusByName).find(
    (name) => name.toLowerCase() === raw.toLowerCase()
  );
  return match ? statusByName[match] : null;
}

const Dashboard = () => {
  window.scrollTo(0, 0);
  const { t } = useTranslation();
  const [listings, setListings] = useState([]);
  const [viewAllListings, setViewAllListings] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState(() => readStatusFromUrl());
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);
  const [citiesLoaded, setCitiesLoaded] = useState(false);
  const [cityId, setCityId] = useState();
  const [imageLoadStatus, setImageLoadStatus] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("poi,listing");
  const navigate = useNavigate();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const accessToken =
      window.localStorage.getItem("accessToken") ||
      window.sessionStorage.getItem("accessToken");
    const refreshToken =
      window.localStorage.getItem("refreshToken") ||
      window.sessionStorage.getItem("refreshToken");

    if (!accessToken && !refreshToken) {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    getCitiesByUserId().then((citiesResponse) => {
      setCities(citiesResponse.data.data);
      setCitiesLoaded(true);
    });
    const cityId = parseInt(urlParams.get("cityId"));
    if (cityId) {
      setCityId(cityId);
    }

    document.title = process.env.REACT_APP_REGION_NAME;
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const pagenoParam = searchParams.get("pageNo");
    if (!isNaN(pagenoParam) && parseInt(searchParams.get("pageNo")) > 1) {
      setPageNo(parseInt(searchParams.get("pageNo")));
    } else {
      searchParams.delete("pageNo");
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
    const accessToken =
      window.localStorage.getItem("accessToken") ||
      window.sessionStorage.getItem("accessToken");
    const refreshToken =
      window.localStorage.getItem("refreshToken") ||
      window.sessionStorage.getItem("refreshToken");
    if (!accessToken && !refreshToken) {
      window.location.href = "/login";
    }
    getCategory().then((response) => {
      const catList = {};
      response?.data?.data.forEach((cat) => {
        catList[cat.id] = cat.name;
        cat.children?.length > 0 && cat.children.forEach((child) => {
          catList[child.id] = child.name;
        });
      });
      setCategories(catList);
    });
    getProfile().then((response) => {
      if (window.location.pathname === "/DashboardAdmin" && (response.data.data.roleId === role.administrator || response.data.data.roleId === role.TerminalAdmin ||  response.data.data.roleId === role.superCityAdmin)) {
        setViewAllListings(true);
      } else {
        setViewAllListings(false);
      }
    });
  }, [window.location.pathname]);

  const fetchListings = useCallback(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const cityIdParam = urlParams.get("cityId");
    if (viewAllListings === true) {
      // cityId comes from the cityAdmin API (getCitiesByUserId). Wait for that
      // response before calling /listings so it fires exactly once and always
      // carries a cityId filter, instead of racing with an empty cityIds value.
      if (!citiesLoaded) {
        return;
      }
      const params = {
        statusId: selectedStatus,
        pageNo,
        // cityId: cityId
      };

      // Check if cityId exists in the URL before adding it to params

      if (cityIdParam) {
        const cityId = parseInt(cityIdParam);
        params.cityIds = cityId;
      } else {
        params.cityIds = cities.map((city) => city.id).join(',')
      }

      const typeParam = selectedType === "poi,listing" ? "poi,listing" : selectedType.toLowerCase();
      params.type = typeParam;

      getListings(params).then((response) => {
        const listingsData = response.data.data;
        setListings(listingsData);
      });
    }
    if (viewAllListings === false) {
      const cityIds = cityIdParam
        ? parseInt(cityIdParam)
        : cities.map((city) => city.id).join(',');

      const typeParam = selectedType === "poi,listing" ? "poi,listing" : selectedType.toLowerCase();

      getMyListing({
        statusId: selectedStatus,
        pageNo,
        type: typeParam,
        // cityIds
      }).then((response) => {
        const listingsData = response.data.data;
        setListings(listingsData);
      });
    }
  }, [selectedStatus, viewAllListings, pageNo, cityId, cities, citiesLoaded, selectedType]);

  useEffect(() => {
    fetchListings();
  }, [fetchListings, pageNo]);

  useEffect(() => {
    setPageNo(1);
  }, [selectedStatus, viewAllListings, selectedType]);

  // function getStatusClass(statusId) {
  //   if (status[statusId] === "Active") {
  //     return "bg-green-400";
  //   }
  //   if (status[statusId] === "Inactive") {
  //     return "bg-red-400";
  //   }
  //   if (status[statusId] === "Pending") {
  //     return "bg-yellow-400";
  //   }
  //   if (status[statusId] === "Hidden") {
  //     return "bg-blue-400";
  //   }
  // }

  const setSelectedStatusAndUpdateURL = (newStatus) => {
    const normalized =
      newStatus === null || newStatus === "" ? null : parseInt(newStatus, 10);
    const urlParams = new URLSearchParams(window.location.search);
    if (normalized && status[normalized]) {
      urlParams.set("status", status[normalized].toLowerCase());
    } else {
      urlParams.delete("status");
    }
    const query = urlParams.toString();
    const newUrl = query
      ? `${window.location.pathname}?${query}`
      : window.location.pathname;
    window.history.replaceState({}, "", newUrl);
    setSelectedStatus(normalized);
  };

  const setPageNoAndUpdateURL = (newPageNo) => {
    if (newPageNo < 1) {
      newPageNo = 1;
    }
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("pageNo", newPageNo);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
    setPageNo(newPageNo);
  };

  const setAllListingsPageNoAndUpdateURL = (newPageNo) => {
    if (newPageNo < 1) {
      newPageNo = 1;
    }
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("pageNo", newPageNo);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
    setPageNo(newPageNo);
  };

  function goToEditListingsPage(listing) {
    const statusQuery =
      selectedStatus && status[selectedStatus]
        ? `&status=${status[selectedStatus].toLowerCase()}`
        : "";
    const fromQuery = `&from=${window.location.pathname}`; // /Dashboard or /DashboardAdmin
    if (listing.categoryId === 18) {
      navigateTo(`/EditListings?listingId=${listing.id}&categoryId=${listing.categoryId}&appointmentId=${listing.appointmentId}${statusQuery}${fromQuery}`);
    } else {
      navigateTo(`/EditListings?listingId=${listing.id}${statusQuery}${fromQuery}`);
    }
  }

  const [showConfirmationModal, setShowConfirmationModal] = useState({
    visible: false,
    listing: null,
    onConfirm: () => { },
    onCancel: () => { },
  });

  const fetchUpdatedListings = useCallback(() => {
    fetchListings();
  }, [fetchListings]);

  function handleDelete(listing) {
    try {
      if (listing.appointmentId) {
        deleteAppointments(listing.cityId, listing.id, listing.appointmentId);
      }
      deleteListing(listing.id, listing.cityId)
        .then((res) => {
          setListings(
            listings.filter(
              (l) => l.cityId !== listing.cityId || l.id !== listing.id
            )
          );
          setShowConfirmationModal({ visible: false });

          fetchUpdatedListings();
          // window.location.reload();
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.log(error);
    }
  }

  function deleteListingOnClick(listing) {
    setShowConfirmationModal({
      visible: true,
      listing,
      onConfirm: () => handleDelete(listing),
      onCancel: () => setShowConfirmationModal({ visible: false }),
    });
  }

  function goToListingPage(listing) {
    if (listing.sourceId === 1 || listing.showExternal === 0) {
      navigateTo(`/Listing?listingId=${listing.id}`);
    } else if (listing.website) {
      window.location.href = listing.website;
    } else {
      navigateTo(`/error`);
    }
  }

  const handleSearch = async (searchQuery, statusName) => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const params = {};
      if (statusName && statusByName[statusName]) {
        params.statusId = statusByName[statusName];
      }

      const cityId = urlParams.get("cityId");
      if (cityId && parseInt(cityId)) {
        params.cityId = parseInt(cityId);
      }

      const categoryId = urlParams.get("categoryId");
      if (categoryId && parseInt(categoryId)) {
        params.categoryId = parseInt(categoryId);
      }
 
      let response=[]
    if(viewAllListings === false){
      const typeParam = selectedType === "poi,listing" ? "poi,listing" : selectedType.toLowerCase();
      response=  await getMyListing({
        searchQuery,
        type: typeParam
      })  
    }
    else{
      const typeParam = selectedType === "poi,listing" ? "poi,listing" : selectedType.toLowerCase();
       response = await getListings({
        searchQuery,
        ...params,
        type: typeParam,
      });
    }
      const listingsData = response.data.data;
      setListings(listingsData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onCityChange = (e) => {
    const selectedCityId = e.target.value;
    const selectedCity = cities.find((city) => city.id.toString() === selectedCityId);
    const urlParams = new URLSearchParams(window.location.search);
    setSearchTerm("");
    if (selectedCity) {
      localStorage.setItem("selectedCity", selectedCity.name);
      urlParams.set("cityId", selectedCityId);
    } else {
      localStorage.setItem("selectedCity", t("allCities"));
      urlParams.delete("cityId");
    }
    urlParams.delete("pageNo");
    setPageNoAndUpdateURL(1)

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
    setCityId(selectedCityId || 0);
  };

  const [cityStatusModal, setCityStatusModal] = useState({
    visible: false,
    listing: null,
  });


  return (
    <section className="bg-gray-900 body-font relative min-h-screen">
      <SideBar />

      <div className="container px-0 sm:px-0 py-0 pb-2 w-full fixed top-0 z-10 lg:px-5 lg:w-auto relative">
        <div className="relative bg-black mr-0 ml-0 px-10 lg:rounded-lg h-18">
          <div className="w-full">
            <div className="w-full h-full flex items-center lg:py-2 py-5 justify-end xl:justify-center lg:justify-center border-gray-100 md:space-x-10">
              <div className="hidden lg:block">
                <div className="w-full h-full flex items-center justify-end xl:justify-center lg:justify-center md:justify-end sm:justify-end border-gray-100 md:space-x-10">
                  <div
                    className={`${selectedStatus === null ? "bg-gray-700 text-white" : "text-gray-300"
                      } hover:bg-gray-700 hover:text-white rounded-md p-4 text-sm font-bold cursor-pointer`}
                    onClick={() => setSelectedStatusAndUpdateURL(null)}
                    style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {t("allListings")}
                  </div>
                  <div
                    className={`${selectedStatus === statusByName.Active ? "bg-gray-700 text-white" : "text-gray-300"
                      } hover:bg-gray-700 hover:text-white rounded-md p-4 text-sm font-bold cursor-pointer`}
                    onClick={() => setSelectedStatusAndUpdateURL(statusByName.Active)}
                    style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {t("active")}
                  </div>
                  <div
                    className={`${selectedStatus === statusByName.Pending ? "bg-gray-700 text-white" : "text-gray-300"
                      } hover:bg-gray-700 hover:text-white rounded-md p-4 text-sm font-bold cursor-pointer`}
                    onClick={() => setSelectedStatusAndUpdateURL(statusByName.Pending)}
                    style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {t("pending")}
                  </div>
                  <div
                    className={`${selectedStatus === statusByName.Inactive ? "bg-gray-700 text-white" : "text-gray-300"
                      } hover:bg-gray-700 hover:text-white rounded-md p-4 text-sm font-bold cursor-pointer`}
                    onClick={() => setSelectedStatusAndUpdateURL(statusByName.Inactive)}
                    style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                  >
                    {t("inactive")}
                  </div>
                </div>
              </div>

              <div className="-my-2 -mr-2 lg:hidden">
                <select
                  className="text-white bg-black font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center border-none focus:outline-none"
                  onChange={(e) => setSelectedStatusAndUpdateURL(e.target.value)}
                  value={selectedStatus || ""}
                  style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                >
                  <option value="">{t("allListings")}</option>
                  <option value={statusByName.Active}>{t("active")}</option>
                  <option value={statusByName.Pending}>{t("pending")}</option>
                  <option value={statusByName.Inactive}>{t("inactive")}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container flex justify-center px-5 py-2 gap-2 w-full md:w-auto fixed lg:w-auto relative">
        <SearchBar
          onSearch={handleSearch}
          searchBarClassName="w-full md:w-80"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        {window.location.pathname.includes("/DashboardAdmin") && (
          <div className="col-span-6 sm:col-span-1 mt-1 mb-1 px-0 mr-0 w-full md:w-80">
            <select
              id="city"
              name="city"
              autoComplete="city-name"
              onChange={onCityChange}
              value={cityId || 0}
              className="bg-white h-10 px-5 pr-10 rounded-full text-sm focus:outline-none w-full text-gray-600"
              style={{
                fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
              }}
            >
              <option className="font-sans" value={0} key={0}>
                {t("allCities", {
                  regionName: process.env.REACT_APP_REGION_NAME,
                })}
              </option>
              {cities.map((city) => (
                <option className="font-sans" value={city.id} key={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="col-span-6 sm:col-span-1 mt-1 mb-1 px-0 mr-0 w-full md:w-80">
          <select
            id="type"
            name="type"
            autoComplete="type-name"
            onChange={(e) => {
              setSelectedType(e.target.value);
              setPageNo(1);
            }}
            value={selectedType}
            className="bg-white h-10 px-5 pr-10 rounded-full text-sm focus:outline-none w-full text-gray-600"
            style={{
              fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            <option className="font-sans" value="poi,listing" key="both">
              {t("both")}
            </option>
            <option className="font-sans" value="poi" key="POI">
              {t("poi")}
            </option>
            <option className="font-sans" value="listing" key="Listing">
              {t("listing")}
            </option>
          </select>
        </div>
      </div>

      <div className="container w-auto px-0 lg:px-5 py-2 bg-gray-900 min-h-screen flex flex-col">
        <div className="h-full">
          <div className="bg-white mt-4 p-0">
            <h2 className="text-xl font-semibold text-gray-800 text-center px-5 py-2" style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}>
              {t("listings")}
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left  text-gray-500  p-6 space-y-10 rounded-lg">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-4 text-start"
                      style={{
                        fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                      }}
                    >
                      {t("listings")}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-start"
                      style={{
                        fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                      }}
                    >
                      {t("type")}
                    </th>
                    <th
                      scope="col"
                      className="px-6 sm:px-3 py-3 hidden lg:table-cell text-center"
                      style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                    >
                      {t("category")}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 hidden lg:table-cell text-center"
                      style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                    >
                      {t("date_of_creation")}
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-center"
                      style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                    >
                      {t("noOfViews")}
                    </th>


                    {viewAllListings && (
                      <>
                        <th
                          scope="col"
                          className="px-6 py-4 text-center"
                          style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                        >
                          {t("current status")}
                        </th>

                        <th
                          scope="col"
                          className="px-6 py-4 text-center"
                          style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                        >
                          {t("status")}
                        </th>
                      </>
                    )}
                    <th
                      scope="col"
                      className="px-6 py-4 text-center"
                      style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                    >
                      {t("action")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {listings.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center py-6 text-black-500 font-semibold">
                        {t("noDataFound")}
                      </td>
                    </tr>
                  ) : (
                    listings.map((listing, index) => {
                      return (
                        <tr
                          key={index}
                          className="bg-white border-b hover:bg-gray-50"
                        >

                          <th
                            scope="row"
                            className="flex items-center justify-start px-6 py-4 text-slate-800 whitespace-nowrap cursor-pointer"
                            onClick={() => {
                              if (!hiddenCategories.includes(listing.categoryId)) {
                                goToListingPage(listing);
                              }
                            }}
                          >
                            {listing.media && listing.media.length > 0 ? (() => {
                              const sortedMedia = listing.media
                                .filter((m) => m.path)
                                .sort((a, b) => a.mediaOrder - b.mediaOrder);

                              const firstPDF = sortedMedia.find((media) =>
                                isListingPdfPath(media.path)
                              );

                              const firstImage = sortedMedia.find(
                                (media) =>
                                  isListingImagePath(media.path) &&
                                  (media.signedUrl || media.path)
                              );

                              const getMediaUrl = (media) =>
                                media.signedUrl ||
                                `${process.env.REACT_APP_MEDIA_URL}${media.path}`;

                              const isLoaded = imageLoadStatus[listing.id];

                              if (firstPDF) {
                                return (
                                  <div className="w-10 h-10 rounded-full overflow-hidden relative">
                                    {!isLoaded && (
                                      <div className="absolute inset-0 flex items-center justify-center bg-gray-200 z-10">
                                        <ClipLoader color="#36D7B7" size={40} />
                                      </div>
                                    )}
                                    <iframe
                                      src={getMediaUrl(firstPDF)}
                                      className="w-full h-full pointer-events-none absolute top-0 left-0"
                                      title="PDF Preview"
                                      onLoad={() =>
                                        setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }))
                                      }
                                      style={{ display: isLoaded ? "block" : "none" }}
                                    />
                                  </div>
                                );
                              } else if (firstImage) {
                                return (
                                  <div className="w-10 h-10 rounded-full overflow-hidden relative">
                                    {!isLoaded && (
                                      <div className="absolute inset-0 flex items-center justify-center bg-gray-200 z-10">
                                        <ClipLoader color="#36D7B7" size={40} />
                                      </div>
                                    )}
                                    <img
                                      className="w-10 h-10 object-cover rounded-full absolute top-0 left-0"
                                      src={getMediaUrl(firstImage)}
                                      alt="listing"
                                      onLoad={() =>
                                        setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }))
                                      }
                                      onError={(e) => {
                                        e.target.src = LISTINGSIMAGE;
                                        setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }));
                                      }}
                                      style={{ display: isLoaded ? "block" : "none" }}
                                    />
                                  </div>
                                );
                              } else {
                                return (
                                  <img
                                    alt="Listing"
                                    className="w-10 h-10 object-cover rounded-full"
                                    src={LISTINGSIMAGE}
                                    onLoad={() =>
                                      setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }))
                                    }
                                    onError={() =>
                                      setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }))
                                    }
                                  />
                                );
                              }
                            })() : (
                              <img
                                alt="Listing"
                                className="w-10 h-10 object-cover rounded-full"
                                src={LISTINGSIMAGE}
                                onLoad={() =>
                                  setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }))
                                }
                                onError={() =>
                                  setImageLoadStatus((prev) => ({ ...prev, [listing.id]: true }))
                                }
                              />
                            )}


                            <div className="pl-0 sm:pl-3 overflow-hidden max-w-[20rem] sm:max-w-[10rem]">
                              <div className="text-gray-500 font-bold truncate" style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}>
                                {listing.title}
                              </div>
                            </div>
                          </th>
                             <td
                            className="px-6 py-4 font-bold text-blue-600 text-center"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                          >
                           {t(listing.type)}
                          </td>
                          <td
                            className="px-6 py-4 hidden lg:table-cell text-center"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                          > 
                            {t(categories[listing.categoryId])}
                          </td>

                          <td
                            className="px-6 py-4 hidden lg:table-cell text-center font-bold text-blue-600"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                          >
                            {new Date(listing.createdAt).toLocaleString("de", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit"
                            })}
                          </td>

                          <td
                            className="px-6 py-4 font-bold text-blue-600 text-center"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                          >
                            {listing.viewCount}
                          </td>



                          {showConfirmationModal.visible && (
                            <div className="fixed z-50 inset-0 flex items-center justify-center overflow-y-auto">
                              <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                <div
                                  className="fixed inset-0 transition-opacity"
                                  aria-hidden="true"
                                >
                                  <div className="absolute inset-0 bg-black/20 backdrop-blur-sm"></div>
                                </div>
                                <span
                                  className="hidden sm:inline-block sm:align-middle sm:h-screen"
                                  aria-hidden="true"
                                >
                                  &#8203;
                                </span>
                                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                      <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                        <svg
                                          className="h-6 w-6 text-red-700"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                          aria-hidden="true"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M6 18L18 6M6 6l12 12"
                                          />
                                        </svg>
                                      </div>
                                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <h3 className="text-lg leading-6 font-medium text-slate-800">
                                          {t("areyousure")}
                                        </h3>
                                        <div className="mt-2">
                                          <p className="text-sm text-gray-500">
                                            {t("doyoureallywanttodeleteListing")}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                    <button
                                      onClick={showConfirmationModal.onConfirm}
                                      type="button"
                                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-800 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                    >
                                      {t("delete")}
                                    </button>

                                    <button
                                      onClick={showConfirmationModal.onCancel}
                                      type="button"
                                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                    >
                                      {t("cancel")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {viewAllListings && (
                            <td className="px-6 py-4 text-center font-medium text-gray-800 text-sm">
                              {listing.cityData?.length > 0 ? (
                                <div className="space-y-1">
                                  {listing.cityData.map((city) => (
                                    <div key={city.id}>
                                      <span className="text-gray-500">{city.name}:</span>{" "}
                                      <span className="font-semibold">
                                        {t(status[city.listingStatus]?.toLowerCase() || "unknown")}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-gray-400 italic">{t("noData")}</span>
                              )}
                            </td>
                          )}
                          {viewAllListings && (
                            <td className="px-6 py-4">
                              <div className="flex items-center justify-center">
                                {/* <div
                              className={`h-2.5 w-2.5 rounded-full ${getStatusClass(
                                listing.statusId
                              )} mr-2`}
                            ></div> */}

                                <button
                                  onClick={() => setCityStatusModal({ visible: true, listing })}
                                  className="text-sm text-blue-600 hover:underline font-semibold"
                                >
                                  {t("manageStatus")}
                                </button>
                                {/* // ) : (
                              //   <h1 style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}>
                              //     {t(status[listing.statusId]?.toLowerCase())}
                              //   </h1> */}

                              </div>
                            </td>
                          )}
                          <td className="px-6 py-4 text-center font-bold">
                            <div className="flex justify-center items-center">
                              <a
                                className={`font-medium text-green-600 px-2 cursor-pointer`}
                                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                                onClick={() => goToEditListingsPage(listing)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="1em"
                                  viewBox="0 0 640 512"
                                  className="w-6 h-6 fill-current transition-transform duration-300 transform hover:scale-110"
                                >
                                  <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
                                </svg>
                              </a>

                              <a
                                className={`font-medium text-red-600 px-2 cursor-pointer`}
                                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                                onClick={() => deleteListingOnClick(listing)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="1em"
                                  viewBox="0 0 640 512"
                                  className="w-6 h-6 fill-current transition-transform duration-300 transform hover:scale-110"
                                >
                                  <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                                </svg>
                              </a>
                            </div>
                          </td>
                          {cityStatusModal.visible && (
                            <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex justify-center items-center px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] z-50">
                              <div className="bg-white rounded-lg p-6 w-full max-w-md">
                                <h2 className="text-xl font-bold mb-4">{t("manageStatus")}</h2>

                                {cityStatusModal.listing.cityData.map((city, index) => (
                                  <div key={city.id} className="mb-4">
                                    <label className="block font-medium text-gray-700">
                                      {city.name}
                                    </label>
                                    <select
                                      value={city.listingStatus}
                                      onChange={(e) => {
                                        const updatedCityData = cityStatusModal.listing.cityData.map((c) =>
                                          c.id === city.id
                                            ? { ...c, listingStatus: parseInt(e.target.value) }
                                            : c
                                        );
                                        setCityStatusModal((prev) => ({
                                          ...prev,
                                          listing: { ...prev.listing, cityData: updatedCityData },
                                        }));
                                      }}
                                      className="w-full mt-1 border border-gray-300 rounded px-3 py-2"
                                    >
                                      {Object.entries(status).map(([id, name]) => (
                                        <option key={id} value={id}>
                                          {t(name.toLowerCase())}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                ))}

                                <div className="flex justify-end mt-6 space-x-3">
                                  <button
                                    onClick={() => setCityStatusModal({ visible: false, listing: null })}
                                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 sm:mt-0 sm:w-auto sm:text-sm"
                                  >
                                    {t("cancel")}
                                  </button>
                                  <button
                                    onClick={async () => {
                                      const payload = {
                                        data: cityStatusModal.listing.cityData.map(city => ({
                                          cityId: city.id,
                                          statusId: city.listingStatus,
                                        }))
                                      };

                                      await updateListingsStatus(cityStatusModal.listing.id, payload);
                                      fetchListings();
                                      setCityStatusModal({ visible: false, listing: null });
                                    }}

                                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-800 text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm"
                                  >
                                    {t("saveChanges")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bottom-5 right-5 mt-5 px-1 py-2 text-xs font-medium text-center float-right cursor-pointer bg-black rounded-xl">
            {pageNo !== 1 ? (
              <span
                className="inline-block bg-black px-2 pb-2 pt-2 text-xs font-bold uppercase leading-normal text-neutral-50"
                onClick={
                  viewAllListings
                    ? () => setAllListingsPageNoAndUpdateURL(pageNo - 1)
                    : () => setPageNoAndUpdateURL(pageNo - 1)
                }
                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
              >
                {"<"}{" "}
              </span>
            ) : (
              <span />
            )}
            <span
              className="inline-block bg-black px-2 pb-2 pt-2 text-xs font-bold uppercase leading-normal text-neutral-50"
              style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
            >
              {t("page")} {pageNo}
            </span>

            {listings.length >= 9 && (
              <span
                className="inline-block bg-black px-2 pb-2 pt-2 text-xs font-bold uppercase leading-normal text-neutral-50"
                onClick={
                  viewAllListings
                    ? () => setAllListingsPageNoAndUpdateURL(pageNo + 1)
                    : () => setPageNoAndUpdateURL(pageNo + 1)
                }
                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
              >
                {">"}
              </span>
            )}
          </div>
        </div>
      </div>
    </section >
  );
};

export default Dashboard;
